module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav_sub_item"
  }, [(_vm.url) ? _c('app-link', {
    staticClass: "nav_sub_link",
    attrs: {
      "link": this.subitem,
      "homeUrl": _vm.homeUrl,
      "description": _vm.description
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.url && _vm.name) ? _c('span', {
    staticClass: "nav_sub_title"
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav_sub_sub"
  }, _vm._l((_vm.links), function(subitem) {
    return _c('navigation-sub', {
      key: subitem.name,
      attrs: {
        "subitem": subitem,
        "homeUrl": _vm.homeUrl
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-628fce8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationSub.vue
// module id = 242
// module chunks = 2